import React from 'react';
import RisksContext from '../risks/RisksContext';
import { useProjectDataContext } from 'domain/shared/newProject';
import { Loading } from 'framework/ui/mui-builder';
import { useProjectRisks } from './hooks/useRisks';

const RisksLayout = () => {
  const { data: projectData } = useProjectDataContext();
  const { loading, risks } = useProjectRisks(projectData.id);

  if (!risks || loading) return <Loading isInitialPosition />;

  return <RisksContext data={risks} />;
};
export default RisksLayout;
